import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { redirectToHost } from 'store/Contextualization/AssetDetail/actions';
import { redirect } from 'store/Router/actions';
import { selectLocation } from 'store/Router/selectors';
import {
  selectAssetDetailId,
  selectHostDetailOwned,
  selectHostDetailOs,
  selectHostDetailUpdateDate,
  selectHostDetailVulns,
  selectHostDetailWorkspaceName,
  selectHostWorkspace
} from 'store/Contextualization/AssetDetail/selectors';
import Title from './Title';
import CopyLink from './CopyLink';
import CopyApiLink from './CopyApiLink';
import {
  Wrapper, HeaderRow, CloseIconWrapper, CloseIcon, Owned,
  MetaBar, MetaItem, MetaLabel, VulnerabilitiesCount
} from './styled';
import { updateHost } from 'store/Host/actions';
import { selectReadOnly } from 'store/Faraday/selectors';
import { redirectToHostsGeneral, updateHostGeneral } from 'store/HostsGeneral/actions';
import TimeAgo from 'react-timeago';
import formatNumber from 'Common/Functions/FormatNumber';

const Header = ({ assetsGeneral, onClose }) => {
  const dispatch = useDispatch();
  const owned = useSelector(selectHostDetailOwned);
  const hostId = useSelector(selectAssetDetailId);
  const os = useSelector(selectHostDetailOs);
  const lastModified = useSelector(selectHostDetailUpdateDate);
  const vulns = useSelector(selectHostDetailVulns);
  const workspaceName = useSelector(selectHostDetailWorkspaceName);
  const intl = useIntl();
  const ownedText = owned ? intl.formatMessage({ id: 'host.hostDetail.owned' }) : intl.formatMessage({ id: 'host.hostDetail.notOwned' });
  const readOnly = useSelector(selectReadOnly);
  const canUpdate = assetsGeneral || !readOnly;
  const workspace = useSelector(selectHostWorkspace);
  const workspaceDisplayName = workspaceName || workspace;
  const location = useSelector(selectLocation);

  const updateOwned = () => {
    if (canUpdate) assetsGeneral ? dispatch(updateHostGeneral(hostId, { owned: !owned }, workspace)) : dispatch(updateHost(hostId, { owned: !owned }));
  };

  const closeDetail = () => {
    if (typeof onClose === 'function') {
      onClose();
      return;
    }

    const search = get(location, 'search', '');
    const params = new URLSearchParams(search || '');
    const fromExplore = params.get('fromExplore') === '1';
    const returnPath = params.get('return');

    if (fromExplore && returnPath) {
      dispatch(redirect(decodeURIComponent(returnPath)));
      return;
    }

    assetsGeneral ? dispatch(redirectToHostsGeneral()) : dispatch(redirectToHost());
  };

  return (
    <Wrapper>
      <HeaderRow>
        <Title assetsGeneral={ assetsGeneral } />
        <VulnerabilitiesCount>
          ({formatNumber(vulns || 0)} {intl.formatMessage({ id: 'host.hostDetail.vulnerabilities' })})
        </VulnerabilitiesCount>
        <Owned owned={ owned } onClick={ updateOwned } disabled={ !canUpdate }>{ ownedText }</Owned>
        <CopyLink />
        <CopyApiLink assetsGeneral={ assetsGeneral } />
        <CloseIconWrapper onClick={ closeDetail }>
          <CloseIcon />
        </CloseIconWrapper>
      </HeaderRow>
      <MetaBar>
        <MetaItem>
          <MetaLabel>{intl.formatMessage({ id: 'host.hostDetail.workspace' })}:</MetaLabel>
          {workspaceDisplayName || '—'}
        </MetaItem>
        <MetaItem>
          <MetaLabel>{intl.formatMessage({ id: 'host.table.columns.os' })}:</MetaLabel>
          {os || '—'}
        </MetaItem>
        <MetaItem>
          <MetaLabel>{intl.formatMessage({ id: 'host.hostDetail.lastModified' })}:</MetaLabel>
          {lastModified ? <TimeAgo date={ lastModified } /> : '—'}
        </MetaItem>
      </MetaBar>
    </Wrapper>
  );
};

export default Header;
